module.exports = __webpack_public_path__ + "img/3.46a3c5ad.jpg";